import React from 'react';
import CooTopBar from './components/CooTopBar';
import CooDashboardContent from './CooDashboardContent';
import BubbleShell from '../chatbot/components/BubbleShell';

/**
 * Standalone COO Dashboard at /coo-dashboard.
 *
 * Body content lives in <CooDashboardContent/> — also reused as the
 * "Executive" view inline in App.js. This file only adds page-level
 * chrome: the top bar and the floating Drishti bubble.
 */
export default function CooDashboardPage() {
  return (
    <div data-coo="page" className="min-h-screen bg-app-bg text-slate-700">
      <CooTopBar />

      <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <CooDashboardContent />
      </main>

      {/* Drishti bubble — floats bottom-right over the dashboard. */}
      <BubbleShell enabled />
    </div>
  );
}
